import React, { Component } from 'react';
import ActionMenu from '../utils/ActionMenu';
import { withRouter  } from 'react-router-dom';
import { optionsMovementCash, optionsTransaction, roleId } from '../../constants/app';

class TableArticlesCash extends Component {    
    handleDoubleClick = (item) => () => {
        if(this.props.role === roleId.admin )
            this.props.history.push(`/handbook/articlesCash/edit/${+item.id}`)
    }

    renderHead() {
        return (
            <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th className="kt-datatable__cell" style={{ width: '22%' }}><span>Название</span></th>
                    <th className="kt-datatable__cell" style={{ width: '22%' }}><span>Категория</span></th>
                    <th className="kt-datatable__cell" style={{ width: '22%' }}><span>Тип</span></th>
                    <th className="kt-datatable__cell" style={{ width: '22%' }}><span>Тип транзакции</span></th>
                    <th className="kt-datatable__cell" style={{ width: 'auto' }}><span>Действия</span></th>
                </tr>
            </thead>
        )
    }
    
    renderBody() {        
        return (
            <>
                {this.renderHead()}
                <tbody className="kt-datatable__body">
                    {
                        this.props.items.map(item => {
                            const actions = [
                                { access: roleId.admin, name: 'Редактирование', icon: 'flaticon2-contract', action: () => this.props.history.push(`/handbook/articlesCash/edit/${+item.id}`) },
                                { access: roleId.admin, name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item)}
                            ].filter(item => !item.access || item.access === this.props.role);
                            return (
                                <tr onDoubleClick={this.handleDoubleClick(item)} key={item.id} className="kt-datatable__row">
                                
                                <td className="kt-datatable__cell" style={{ width: '22%' }}>
                                    <span>
                                        {item.name}
                                    </span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '22%' }}>
                                    <span>
                                        {(item.category && item.category.name) ? item.category.name : '-'}
                                    </span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '22%' }}>
                                    <span>
                                        {optionsMovementCash.find((option) => option.value === item.typeMovementCash).label}
                                    </span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '22%' }}>
                                    <span>
                                        {optionsTransaction.find((option) => option.value === item.typeTransaction).label}
                                    </span>
                                </td>                            
                                <td className="kt-datatable__cell" style={{ width: 'auto' }}>
                                    <ActionMenu actions={actions}/>
                                </td>
                            </tr>
                            )
                        }) 
                    }
                </tbody>
            </>
        );
        
    }

    renderBodyMobile(){
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map(item => {
                        const actions = [
                            { access: roleId.admin, name: 'Редактирование', icon: 'flaticon2-contract', action: () => this.props.history.push(`/handbook/articlesCash/edit/${+item.id}`) },
                            { access: roleId.admin, name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item)}
                        ].filter(item => !item.access || item.access === this.props.role);
                        return (
                            <tr onDoubleClick={this.handleDoubleClick(item)} key={item.id} className="kt-datatable__row">
                            <div className='mobile_div_flex column padding10px'>
                                <div className='mobile_div_flex gap0px'>
                                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                                        <span>
                                            {`Название: ${item.name}`}
                                        </span>
                                    </div>
                                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                                        <span>
                                            {`Тип: ${optionsMovementCash.find((option) => option.value === item.typeMovementCash).label}`}
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex gap0px'>
                                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                                        <span>
                                            {`Категория: ${(item.category && item.category.name) ? item.category.name : '-'}`}
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex gap0px'>
                                    <div className='mobile_div_flex' style={{ width: 'calc(50% - 5px)' }}>
                                        <span>
                                            {`Тип транзакции: ${optionsTransaction.find((option) => option.value === item.typeTransaction).label}`}
                                        </span>
                                    </div>
                                    <div className='mobile_div_flex' style={{ width: '50%', justifyContent: 'flex-start' }}>
                                        <span>
                                            <ActionMenu actions={actions}/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return (
                <div>Статей не найдено</div>
            );
        }

        if(window.innerWidth < 500)
            return (
                <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                    {this.renderBodyMobile()}
                </table>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderBody()}
            </table>
        );
    }
}

export default withRouter(TableArticlesCash);